<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/other-delivery/${this.$route.params.id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/other-delivery/${this.$route.params.id}/edit`,
                    },
                ],
            };
        },
    };
</script>
